import { render, staticRenderFns } from "./DeliveryListCard.vue?vue&type=template&id=4602719e&scoped=true"
import script from "./DeliveryListCard.vue?vue&type=script&lang=js"
export * from "./DeliveryListCard.vue?vue&type=script&lang=js"
import style0 from "./DeliveryListCard.vue?vue&type=style&index=0&id=4602719e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4602719e",
  null
  
)

export default component.exports